// extracted by mini-css-extract-plugin
export default {"photos":"index-module--photos--b1d8b","grid":"index-module--grid--067f6","carousel":"index-module--carousel--6a3ea","tools":"index-module--tools--a5473"};